import { LucideAlertCircle } from 'lucide-react';

import { cn } from '../../../lib';
import { Col } from '../containers';
import { Loading } from '../feedback/Loading';

export const AsyncBoundary = ({
  children,
  error,
  loading,
  showLoadingLabel = true,
  className,
  style,
}: {
  children: React.ReactNode;
  error: Error | null | undefined;
  loading: boolean | undefined;
  showLoadingLabel?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) => {
  if (loading) {
    return (
      <Loading
        isLoading
        className={cn('size-full', className)}
        showLabel={showLoadingLabel}
        style={style}
      />
    );
  }
  if (error) {
    return (
      <Col
        xCenter
        yCenter
        gap2
        className={cn('size-full px-10', className)}
        style={style}
      >
        <LucideAlertCircle className="size-15 stroke-1 text-failure opacity-40" />

        <Col xCenter className={'text-center'}>
          <div className={'text-failure'}>
            {error.message || 'Error loading data'}
          </div>
          <div className={'text-sm text-failure/50'}>
            Please, try again later
          </div>
        </Col>
      </Col>
    );
  }

  return children;
};
